// src/app/redux/sagas/workflowSagas.js

import { call, put, takeLatest } from 'redux-saga/effects';
import { getRequest, postRequest, deleteRequest } from '../../../api';
import Swal from "sweetalert2";
import {
    FETCH_WORKFLOWS_REQUEST,
    FETCH_WORKFLOWS_SUCCESS,
    FETCH_WORKFLOWS_FAIL,
    SAVE_WORKFLOW_REQUEST,
    SAVE_WORKFLOW_SUCCESS,
    SAVE_WORKFLOW_FAIL,
    DELETE_WORKFLOW_REQUEST,
    DELETE_WORKFLOW_SUCCESS,
    DELETE_WORKFLOW_FAIL,
} from '../actions/workflowActions';

import { API_BASE_URL } from '../../../api';

const API_URL = `${API_BASE_URL}/api/user-field-workflows`;

function* fetchWorkflowsSaga(action) {
    try {
        const response = yield call(getRequest, { url: `${API_URL}?companyId=${action.payload}`, token: sessionStorage.getItem('token') });
        yield put({ type: FETCH_WORKFLOWS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_WORKFLOWS_FAIL, payload: error.message });
    }
}

function* saveWorkflowSaga(action) {
    try {
        const response = yield call(postRequest, { url: API_URL, data: action.payload, token: sessionStorage.getItem('token') });
        yield put({ type: SAVE_WORKFLOW_SUCCESS, payload: response.data });
        
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Règle de validation enregistrée',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put({ type: SAVE_WORKFLOW_FAIL, payload: error.message });
        
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de l'enregistrement",
            timer: 2500,
            showConfirmButton: false
        });
    }
}

function* deleteWorkflowSaga(action) {
    try {
        yield call(deleteRequest, { url: `${API_URL}/${action.payload}`, token: sessionStorage.getItem('token') });
        yield put({ type: DELETE_WORKFLOW_SUCCESS, payload: action.payload });
        
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Règle supprimée',
            timer: 2000,
            showConfirmButton: false
        });
    } catch (error) {
        yield put({ type: DELETE_WORKFLOW_FAIL, payload: error.message });
        
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la suppression",
            timer: 2500,
            showConfirmButton: false
        });
    }
}

export default function* workflowSaga() {
    yield takeLatest(FETCH_WORKFLOWS_REQUEST, fetchWorkflowsSaga);
    yield takeLatest(SAVE_WORKFLOW_REQUEST, saveWorkflowSaga);
    yield takeLatest(DELETE_WORKFLOW_REQUEST, deleteWorkflowSaga);
}
